import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import ViewPort from "../Layout/ViewPort";
import useUser from "../../hooks/useUser";
import useLocationState from "../../hooks/useLocationState";
import { Help } from 'ss-lib';

const HowTo = () => {
  const { user, isJournalManager, setTitle } = useUser();
  const { state } = useLocationState();
  const h = useRef(null);

  useEffect(() => {
    document.title = "ScholarSift - Tutorials";
    setTitle("Tutorials")
  });

  useEffect(() => {
    let v = state.viewport.h - (state.viewport.m + state.viewport.f);
    if (v !== h.current) h.current = v;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.viewport]);
  
  //Assigning editors
  const isAssignor = user.current && user.current.scholarsift && user.current.scholarsift.groupPrefs && user.current.scholarsift.groupPrefs.find(v => v["/submissions/manager"].canAssign) !== undefined;
  
  return (
    <ViewPort
      style={{
        height: h.current,
        overflow: "auto",
      }}
    >
      <div style={{ minHeight: h.current - 10, height: "fit-content" }}>
        <Help isJournalManager={isJournalManager} isAssignor={isAssignor} />
      </div>
    </ViewPort>
  );
};

export default HowTo;
